class DateFormatter {
    static fromTimeStampToDate(timestamp) {
        var date = new Date(timestamp * 1000);
        return (
            (date.getDate() + "").padStart(2, "0") +
            "." +
            (date.getMonth() + 1 + "").padStart(2, "0") +
            "." +
            date.getFullYear()
        );
    }

    static fromTimeStampToTime(timestamp) {
        var date = new Date(timestamp * 1000);
        return (
            (date.getHours() + "").padStart(2, "0") +
            ":" +
            (date.getMinutes() + "").padStart(2, "0")
        );
    }

    static fromTimeStampToYYYYMMDD(timestamp) {
        var date = new Date(timestamp * 1000);
        return (
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1 + "").padStart(2, "0") +
            "-" +
            (date.getDate() + "").padStart(2, "0")
        );
    }

    static fromTimestampToRFC3339(timestamp) {
        var date = new Date(timestamp * 1000);
        function pad(n) {
            return n < 10 ? "0" + n : n;
        }
        return (
            date.getUTCFullYear() +
            "-" +
            pad(date.getUTCMonth() + 1) +
            "-" +
            pad(date.getUTCDate()) +
            "T" +
            pad(date.getUTCHours()) +
            ":" +
            pad(date.getUTCMinutes()) +
            ":" +
            pad(date.getUTCSeconds()) +
            "Z"
        );
    }

    static fromTimeStampToWeekDay(timestamp) {
        var date = new Date(timestamp * 1000);
        return DateStrings.short_week_days[date.getDay()];
    }
}

const DateStrings = {
    "short_week_days": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
}

export default DateFormatter;
